import React, { PureComponent } from 'react'
// import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import PageHeaderWrapper from '../PageHeaderWrapper'
import {
  Form,
  Input,
  Spin,
  Button,
  Card,
  List,
  Row,
  Col,
  Checkbox,
  Upload,
  Icon,
  Select,
  AutoComplete,
  Tag,
  Radio,
  Descriptions,
  DatePicker,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'

import { getUrlPushWrapper } from '../../routes'
import { API_URL } from '../../request'

import 'react-quill/dist/quill.snow.css'
import { notification } from 'antd/lib/index'
// import { hideLoader, showLoader } from '../../../modules/actions'
import Request from '../../request'
import { connect } from 'react-redux'
import { createMatchSelector, goBack } from 'connected-react-router'

import styles from './styles.less'

const { Option } = Select

class ComplaintStats extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      total: null,
      newData: ['one'],
      prevDisableDate: props.disableDate,
    }
  }
  apiFunction = async () => {
    this.setState({ total: null, newData: ['one'] })
    let params = {
      startRange: this.props.startRange,
      lastRange: this.props.lastRange,
      disableDate: this.props.disableDate,
    }

    const { data, error } = await Request.getComplaintCount({ ...params })

    if (!error) {
      if (data.length > 0) {
        this.setState({ total: data[0], newData: data })
      }
    }
  }
  async componentDidMount() {
    this.apiFunction()
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.disableDate !== this.props.disableDate ||
      prevProps.startRange !== this.props.startRange ||
      prevProps.lastRange !== this.props.lastRange
    ) {
      this.apiFunction()
      this.setState({ prevDisableDate: this.props.disableDate })
    }
  }

  render() {
    const { dispatch, startRange, lastRange, onRangeChange, disableDate } =
      this.props
    const { total } = this.state

    return (
      <>
        <Row style={{ marginBottom: '15px' }} gutter={16}>
          <Col>
            <Card
              title={
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                  }}>
                  <span style={{ fontSize: '16px' }}>
                    <img
                      src="/test/orders-count.svg"
                      alt="Icon"
                      style={{
                        height: '15px',
                        marginRight: '5px',
                        marginBottom: '4px',
                      }}
                    />
                    Complaint Count
                  </span>
                  <DatePicker.RangePicker
                    disabled={disableDate}
                    style={{ width: 220 }}
                    format="DD-MM-YYYY"
                    value={[moment(startRange), moment(lastRange)]}
                    onChange={(value) => onRangeChange && onRangeChange(value)}
                  />
                </div>
              }
              bordered={false}
              headStyle={{
                // backgroundColor: '#FF6347 ',
                // textAlign: 'center',
                // color: 'white',
                fontSize: '15px',
                fontWeight: '600',
                borderBottom: 'none',
                marginBottom: '-10px',
                marginLeft: '-3px',
              }}
              bodyStyle={{ padding: '7px 20px', maxHeight: '236px' }}
              style={{
                // marginRight: '10px',
                // height: '290px',
                padding: '10px !important',
                marginTop: '15px',
              }}>
              <List
                size="small"
                bordered={false}
                dataSource={this.state.newData || []}
                renderItem={(val) => (
                  <>
                    <List.Item>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-around',
                          width: '100%',
                        }}>
                        <div
                          style={{
                            width: '60%',
                            textAlign: 'start',
                            color: '#686B75',
                            fontWeight: '400',
                          }}>
                          Total Complaints
                        </div>
                        <div
                          style={{
                            width: '40%',
                            textAlign: 'end',
                          }}>
                          <a
                            target={'_blank'}
                            href={`/complaint/closeComplaintForAdmin`}
                            style={{
                              width: '40%',
                              textAlign: 'end',
                              color: '#2B2539',
                              fontWeight: '600',
                            }}>
                            {total !== null ? total.totalCount : 0}
                          </a>
                        </div>
                      </div>
                    </List.Item>
                    <List.Item>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-around',
                          width: '100%',
                        }}>
                        <div
                          style={{
                            width: '60%',
                            textAlign: 'start',
                            color: '#686B75',
                            fontWeight: '400',
                          }}>
                          Open
                        </div>
                        <div
                          style={{
                            width: '40%',
                            textAlign: 'end',
                          }}>
                          <a
                            target={'_blank'}
                            href={`/complaint/closeComplaintForAdmin?type=Open`}
                            style={{
                              width: '40%',
                              textAlign: 'end',
                              color: '#2B2539',
                              fontWeight: '600',
                            }}>
                            {total !== null ? total.open : 0}
                          </a>
                        </div>
                      </div>
                    </List.Item>
                    <List.Item>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-around',
                          width: '100%',
                        }}>
                        <div
                          style={{
                            width: '60%',
                            textAlign: 'start',
                            color: '#686B75',
                            fontWeight: '400',
                          }}>
                          Fixed By Technician
                        </div>
                        <div
                          style={{
                            width: '40%',
                            textAlign: 'end',
                          }}>
                          <a
                            target={'_blank'}
                            href={`/complaint/closeComplaintForAdmin?type=Fixed By Technician`}
                            // onClick={() => {
                            //   dispatch(
                            //     getUrlPushWrapper('Complaint.list', {
                            //       type: 'Fixed By Technician',
                            //     })
                            //   )
                            // }}
                            style={{
                              width: '40%',
                              textAlign: 'end',
                              color: '#2B2539',
                              fontWeight: '600',
                            }}>
                            {total !== null ? total.fixedByTech : 0}
                          </a>
                        </div>
                      </div>
                    </List.Item>
                    <List.Item>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-around',
                          width: '100%',
                        }}>
                        <div
                          style={{
                            width: '60%',
                            textAlign: 'start',
                            color: '#686B75',
                            fontWeight: '400',
                          }}>
                          Complaint To Head Office
                        </div>
                        <div
                          style={{
                            width: '40%',
                            textAlign: 'end',
                          }}>
                          <a
                            target={'_blank'}
                            href={`/complaint/closeComplaintForAdmin?type=Complaint To Head Office`}
                            // onClick={() => {
                            //   dispatch(
                            //     getUrlPushWrapper('Complaint.list', {
                            //       type: 'Fixed By Technician',
                            //     })
                            //   )
                            // }}
                            style={{
                              width: '40%',
                              textAlign: 'end',
                              color: '#2B2539',
                              fontWeight: '600',
                            }}>
                            {total !== null ? total.complaintToHeadOffice : 0}
                          </a>
                        </div>
                      </div>
                    </List.Item>
                    <List.Item>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-around',
                          width: '100%',
                        }}>
                        <div
                          style={{
                            width: '60%',
                            textAlign: 'start',
                            color: '#686B75',
                            fontWeight: '400',
                          }}>
                          Transfer To ASC
                        </div>
                        <div
                          style={{
                            width: '40%',
                            textAlign: 'end',
                          }}>
                          <a
                            target={'_blank'}
                            href={`/complaint/closeComplaintForAdmin?type=Transfer To ASC`}
                            // onClick={() => {
                            //   dispatch(
                            //     getUrlPushWrapper('Complaint.list', {
                            //       type: 'Fixed By Technician',
                            //     })
                            //   )
                            // }}
                            style={{
                              width: '40%',
                              textAlign: 'end',
                              color: '#2B2539',
                              fontWeight: '600',
                            }}>
                            {total !== null ? total.transferToAsc : 0}
                          </a>
                        </div>
                      </div>
                    </List.Item>
                    <List.Item>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-around',
                          width: '100%',
                        }}>
                        <div
                          style={{
                            width: '60%',
                            textAlign: 'start',
                            color: '#686B75',
                            fontWeight: '400',
                          }}>
                          Close
                        </div>
                        <div
                          style={{
                            width: '40%',
                            textAlign: 'end',
                          }}>
                          <a
                            target={'_blank'}
                            href={`/complaint/closeComplaintForAdmin?type=Close`}
                            // onClick={() => {
                            //   dispatch(
                            //     getUrlPushWrapper('Complaint.list', {
                            //       type: 'Close',
                            //     })
                            //   )
                            // }}
                            style={{
                              width: '40%',
                              textAlign: 'end',
                              color: '#2B2539',
                              fontWeight: '600',
                            }}>
                            {total !== null ? total.close : 0}
                          </a>
                        </div>
                      </div>
                    </List.Item>
                  </>
                )}></List>
            </Card>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
})
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ComplaintStats)
